import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';
import axios from "axios";
import {init, identify, Identify, groupIdentify } from '@amplitude/analytics-browser';
// import AMPLITUDE_API_KEY from './lib/utils'

Sentry.init({ dsn: "https://5a5f463c1d5b4d2c83e8bea3d4a2fa77@sentry.io/1836030" });
const AMPLITUDE_API_KEY = '21b3ad734059f9a59efb9e6a65422523';

// -------------------- APIs Config ----------------

// Axios Token Interceptor


const setAPIToken = () => {
let token = localStorage.getItem("token");
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};
setAPIToken();

axios.interceptors.request.use((request) => {
// Setting the server timeout to be 45 seconds, 
// this doesn't stop api hit if the user internet connection is not working.
axios.defaults.timeout = 45000;
console.log(request);
return request;
});

// Amplitude Tracking
if (localStorage.getItem("user")) {
  let user = JSON.parse(localStorage.getItem("user"));
  const identifyobj = new Identify();
  identifyobj.setOnce("User Id", `${user.user_id}`);
  identifyobj.set("Roll Number", `${user.roll_number}`);
  identifyobj.set("User Name", `${user.name}`);
  identifyobj.set("College Name", `${user.college_name}`);
  identifyobj.set("College Id", `${user.college_id}`);
  identifyobj.set("Gender", `${user.gender}`);
  identifyobj.set("Semester Id", `${user.semester_id}`);
  identifyobj.set("Section Name", `${user.section_name}`);
  identifyobj.set("Section Id", `${user.section_id}`);
  identifyobj.set("Department Name", `${user.department_name}`);
  identifyobj.set("Department Id", `${user.department_id}`);
  identify(identifyobj);
  init(AMPLITUDE_API_KEY, `${user.user_id}`);
}


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();